import { createSelector } from 'reselect';
import { searchProjectListSelector, makeNullSafeDomainGetter, createIsLoadingSelector, makeByIdsDictionarySelector } from './common';

const projectSearchListSelector = makeNullSafeDomainGetter(searchProjectListSelector, 'searchPoiV2');
export const isLoadingProjectSearchListSelector = createIsLoadingSelector(searchProjectListSelector);
export const poiSearchProjectListSelector = createSelector([
  projectSearchListSelector,
], (searchPoi) =>
  searchPoi && searchPoi.poi && searchPoi.poi.filter(Boolean) || []);
export const projectsByIdsSelector = makeByIdsDictionarySelector(poiSearchProjectListSelector);
